import { render, staticRenderFns } from "./MilestoneApproveInvoices.vue?vue&type=template&id=5782a06d&"
import script from "./MilestoneApproveInvoices.vue?vue&type=script&lang=js&"
export * from "./MilestoneApproveInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports